export default {
	a_great_community_awaits_you: 'Uma grande comunidade te aguarda',
	about_the: 'Sobre a',
	access_platform: 'Acessar plataforma',
	access: 'Acessar',
	active_users: '{users} usuários ativos',
	an_email_has_been_sent_to: 'Um email foi enviado para',
	are_you_a_continental_partner: 'Você é um parceiro Continental?',
	certificates_obtained_in_training: 'Certificados obtidos nos treinamentos',
	change_country: "Alterar país",
	check_your_email_for_password_recovery_instructions:
		'Cheque o seu email para ver as instruções de recuperação de senha.',
	click_on_the_button_below_to_perform_the_first_access:
		'Clique no botão abaixo para realizar o primeiro acesso',
	code: 'Código',
	to_the_document_informed: 'ao documento informado.',
	ddd_plus_number_ex: 'DDD mais número. Ex. 1199999999',
	discover_new_techniques_in_current_and_diversified_courses:
		'Conheça novas técnicas em cursos atuais e diversificados',
	do_apply: 'Se aplicam',
	document_cpf: 'CPF',
	document: 'Documento',
	email_already_in_use_click: 'Email já em uso. Clique',
	enter_full_company_name: "Digite o nome completo da empresa",
	email_invalid_error: 'Endereço de e-mail inválido' ,
	enter_a_new_password: 'Informe uma nova senha.',
	enter_the_code_received_through_the_selected_recovery_method_to_create_a_new_password:
		'Informe o código recebido através do método de recuperação selecionado para criar uma nova senha',
	enter_your_document_to_check_the_options_available_with_your_phone_number_for_password_recovery:
		'Informe o seu documento para verificar as opções disponíveis com seu número de telefone para recuperação de senha.',
	enter_your_new_password: 'Informe sua nova senha',
	enter_your_phone_number_below_and_press_send_to_receive_a_confirmation_code:
		'Digite abaixo o número do seu telefone e pressione enviar para receber um código de confirmação.',
	error_logging_in_check_the_user_and_password_entered:
		'Erro ao efetuar logon. Verifique o usuário e senha digitados.',
	error_setting_new_password: 'Erro ao definir nova senha.',
	forgot_password: 'Esqueci a senha',
	select_an_available_option_to_receive_the_verification_code: 'Selecione uma opção disponível para receber o código de verificação.',
	in: 'em',
	log_in_to_receive_an_email_with_instructions_and_a_link_to_create_a_new_password:
		'Identifique-se para receber um email com as instruções e o link para criar uma nova senha.',
	login_to_access_your_account: 'Entre para acessar sua conta',
	more_than_courses: 'Mais de {courses} cursos',
	no_company_agency_found: 'Nenhuma empresa/agência encontrada',
	or: 'Ou',
	password_changed_successfully: 'Senha alterada com sucesso.',
	password_setting_link_expired:
		'Link para definição de senha expirado. Clique aqui em “Esqueci minha senha” para solicitar um novo link.',
	phone_number: 'Número de telefone',
	Please_wait_we_are_validating_your_access: 'Por favor, aguarde. Estamos validando o seu acesso.',
	recover_password_with_sms: 'Recuperar senha com celular',
	recover_password_with_username: 'Recuperar senha com nome de usuário',
	recover_password: 'Recuperar senha',
	recover_your_password: 'Recupere sua senha',
	request_code: 'Solicitar código',
	request_new_code: 'Solicitar novo código',
	sap_code: 'Código SAP ou CNPJ',
	seconds: 'segundos',
	select_your_country: 'Escolha o seu país',
	select: 'Selecionar',
	send_code: 'Enviar código',
	set_new_password: 'Definir nova senha',
	sign_in: 'Entrar',
	sign_up: 'Cadastre-se',
	temporary_password: 'Senha provisória',
	terms_of_service: 'Termos de Serviço',
	the_code_sent_is_not_valid: 'O código enviado não é válido',
	the_informed_user_could_not_be_found_please_check_the_data_provided:
		'Não foi possível localizar o usuário informado. Por favor verifique os dados informados.',
	the_number_entered_does_not_correspond_to_the_registered_number:
		'O número informado não corresponde ao número cadastrado',
	the_password_reset_link_is_invalid:
		'O Link para redefinição de senha é inválido. Por favor solicite um novo.',
	there_is_no_registered_phone_for_this_user: 'Não existe telefone cadastrado para esse usuário',
	this_site_is_protected_by_googles_recaptcha: 'Esse site é protegido pelo reCAPTCHA do Google',
	to_access_this_website_you_need_to_login_first_at_the_intel_retail_edge_program_and_click_on_the_intel_rewards_you_link_on_the_menu:
		'Para acessar esse website, você precisa primeiro logar-se no Programa Intel® Retail Edge e clicar em "Intel Te Premia" no menu.',
	to_recover_your_password: 'para recuperar sua senha',
	under_maintenance: 'Em manutenção',
	use_document_and_default_password_to_login:
		'Digite o seu documento de login para receber um e-mail com instruções e um link para criar uma nova senha.',
	use_only_numbers_ex: 'Use apenas números. Ex. 123456789',
	use_your_email_or_document_to_recover_your_password:
		'Utilize seu email ou documento para recuperar sua senha',
	user_doesnt_have_access: 'Usuário não possui acesso',
	user_registered_success: 'Usuário registrado com sucesso.',
	we_are_under_renovation_and_soon_we_will_bring_a_new_platform_full_of_news_for_you:
		'Estamos em reforma e em breve teremos uma plataforma nova cheia de novidades para você!',
	we_found_the_phone_number: 'Encontramos opções correspondentes ao número de telefone',
	welcome_to: 'Bem-vindo(a) à',
	to_recover_your_password_using_email_or_sms:
		'para recuperar sua senha via E-mail ou SMS cadastrados. ',
	you_can_recover_your_password_using_your_email_or_document_or_sms:
		"Clique em 'Esqueci minha senha' e escolha recuperar por E-mail (use seu documento ou E-mail) ou por SMS (use seu número de celular) e receba um LINK para fazer sua nova senha. ",
	you_can_recover_your_password_using_your_email_or_sms:
		"Clique em 'Esqueci minha senha' e escolha recuperar por E-mail ou por SMS (use seu número de celular) e receba um LINK para fazer sua nova senha. ",
	password_recovery: 'Recuperação de senha',
	login_azure: 'Acesso Direto',
	user_not_found_contact_to: 'Usuário não encontrado. Entre em contato com',
	to_request_to_access_on_the_platform: 'para solicitar acesso à plataforma.',
}
